import clsx, { type ClassValue } from 'clsx';

/**
 * Class-name join. Deliberately thin: this design system expresses variants
 * through explicit lookup maps rather than merged utility soup, so there is no
 * need for tailwind-merge and no ambiguity about which class wins.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
